export const translations = {
  en: {
    // Home
    hi: "Hi,",
    im: "I'm",
    name: " Sebastián",
    job: "Software developer.",
    techs: "JavaScript | ReactJs | NodeJS | ExpressJS | MongoDB | HTML5 | CSS3 | SASS | Git",
    contactMe: "CONTACT ME",
    viewCV: "VIEW MY CV",
    
    // About
    aboutMe: "About me",
    aboutDescription1: "Software developer, with excellent command of the English language, knowledge in different programming languages and technologies such as JavaScript, TypeScript, ReactJs, Git, web development technologies, good SEO positioning practices, relational and non-relational databases, among other current technologies.",
    aboutDescription2: "Always willing to explore and delve into new topics and with the ability to meet requirements.",
    aboutDescription3: "Check out my",
    linkedin: "Linkedin",
    and: "and my",
    github: "Github",
    
    // Contact
    contactTitle: "Contact me",
    contactDescription: "Let's collaborate and create something amazing together! If you're interested in working with me, have questions, or just want to say hello, feel free to reach out.",
    namePlaceholder: "Name",
    emailPlaceholder: "Email",
    subjectPlaceholder: "Subject",
    messagePlaceholder: "Message",
    send: "Send",
    messageSuccess: "Message successfully sent!",
    messageError: "Can not send the message please try again :(",
    
    // Projects
    projects: "Projects",
    view: "View",
    
    // Document titles
    homeTitle: "Home",
    aboutTitle: "About me",
    contactTitle: "Contact",
    projectsTitle: "Projects"
  },
  es: {
    // Home
    hi: "Hola,",
    im: "Soy",
    name: " Sebastián",
    job: "Desarrollador de software.",
    techs: "JavaScript | ReactJs | NodeJS | ExpressJS | MongoDB | HTML5 | CSS3 | SASS | Git",
    contactMe: "CONTÁCTAME",
    viewCV: "VER MI HOJA DE VIDA",
    
    // About
    aboutMe: "Acerca de mí",
    aboutDescription1: "Desarrollador de software, con excelente dominio del idioma inglés, con conocimientos en diferentes lenguajes de programación y tecnologías como JavaScript, TypeScript, ReactJs, Git, tecnologías de desarrollo web, buenas prácticas de posicionamiento SEO, bases de datos relacionales y no relacionales, entre otras tecnologías actuales.",
    aboutDescription2: "Siempre dispuesto a explorar y profundizar en nuevos temas y con la capacidad de cumplir con los requisitos.",
    aboutDescription3: "¡Mira mi",
    linkedin: "Linkedin",
    and: "y mi",
    github: "Github",
    
    // Contact
    contactTitle: "Contáctame",
    contactDescription: "¡Colaboremos y creemos algo increíble juntos! Si estás interesado en trabajar conmigo, tienes preguntas o simplemente quieres saludar, no dudes en contactarme.",
    namePlaceholder: "Nombre",
    emailPlaceholder: "Correo electrónico",
    subjectPlaceholder: "Asunto",
    messagePlaceholder: "Mensaje",
    send: "Enviar",
    messageSuccess: "¡Mensaje enviado exitosamente!",
    messageError: "No se pudo enviar el mensaje, por favor intenta de nuevo :(",
    
    // Projects
    projects: "Proyectos",
    view: "Ver",
    
    // Document titles
    homeTitle: "Inicio",
    aboutTitle: "Acerca de mí",
    contactTitle: "Contacto",
    projectsTitle: "Proyectos"
  }
};
